import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'users';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const MEMBERSHIP_REMOVE = createApiNamespacedConstants('membership_remove');
export const ROLE_UPDATE = createApiNamespacedConstants('role_update');
export const TEAM_ASSIGNMENT = createApiNamespacedConstants('team_assignment');
export const USERLIST_GET = createApiNamespacedConstants('userlist_get');
export const USER_PATCH = createApiNamespacedConstants('user_patch');
export const USER_DEACTIVATE = createApiNamespacedConstants('user_deactivate');
export const USER_REACTIVATE = createApiNamespacedConstants('user_reactivate');
export const PATCH_ORGANIZATION = createApiNamespacedConstants('patch_organization');
export const GET_ORGANIZATION_USERS_USAGE_CSV = createApiNamespacedConstants('get_organization_users_usage_csv');
export const CLEAR_FILTERS = `${NAMESPACE}/CLEAR_FILTERS`;
export const TOGGLE_FILTER = `${NAMESPACE}/TOGGLE_FILTER`;
export const UPDATE_OFFSET = `${NAMESPACE}/UPDATE_OFFSET`;
